<ng-container *ngIf="allCounts">
  <div class="counts">
    <ng-container *ngFor="let count of countsToDisplay">
      <ng-container [ngSwitch]="count">
        <ng-container *ngSwitchCase="'leadCounts'">
          <app-lead-counts [leadCounts]="allCounts.leadCount"></app-lead-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'appointmentCounts'">
          <app-appointment-counts
            [appointmentCounts]="allCounts.appointmentCount"
          ></app-appointment-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'customerVisitCounts'">
          <app-customer-visit-counts
            [customerVisitCounts]="allCounts.customerVisitCount"
            [fxShow.xs]="false"
            [fxShow.sm]="false"
          ></app-customer-visit-counts>
        </ng-container>
        <!-- <ng-container *ngSwitchCase="'proposalCounts'">
          <app-proposal-counts
            [proposalCounts]="allCounts.proposalCount"
          ></app-proposal-counts>
        </ng-container> -->
        <ng-container *ngSwitchCase="'salesManagementCounts'">
          <app-sales-management-counts
            [salesManagementCounts]="allCounts.salesManagementCount"
          ></app-sales-management-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'productionSchedulingCounts'">
          <app-production-scheduling-counts
            [productionSchedulingCounts]="allCounts.productionSchedulingCount"
          ></app-production-scheduling-counts>
        </ng-container>
        <!-- <ng-container *ngSwitchCase="'productionCounts'">
          <app-production-counts
            [productionCounts]="allCounts.productionCount"
          ></app-production-counts>
        </ng-container> -->
        <ng-container *ngSwitchCase="'productionManagementCounts'">
          <app-production-management-counts
            [productionManagementCounts]="allCounts.productionManagementCount"
          ></app-production-management-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'serviceCounts'">
          <app-service-counts
            [serviceCounts]="allCounts.serviceCount"
          ></app-service-counts>
        </ng-container>
        <!-- <ng-container *ngSwitchCase="'digCounts'">
          <app-dig-counts [digCounts]="allCounts.digsCount"></app-dig-counts>
        </ng-container> -->
        <ng-container *ngSwitchCase="'permitCounts'">
          <app-permit-counts
            [permitCounts]="allCounts.permitCount"
          ></app-permit-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'utilitiesCount'">
          <app-utility-counts
            [utilityCounts]="allCounts.utilitiesCount"
          ></app-utility-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'serviceManagementCounts'">
          <app-service-management-counts
            [serviceManagementCounts]="allCounts.serviceManagementCount"
          ></app-service-management-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'cclCounts'">
          <app-ccl-counts [cclCounts]="allCounts.cclCount"></app-ccl-counts>
        </ng-container>
        <ng-container *ngSwitchCase="'accountingCounts'">
          <app-accounting-counts
            [accountingCounts]="allCounts.accountingCount"
          ></app-accounting-counts>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <!-- <mat-icon class="down-icon"> keyboard_arrow_down </mat-icon> -->
</ng-container>
